export default "__VITE_ASSET__51344086__"